var exports = {
  "kL": "x7be19a29--56a955--container",
  "iW": "x7be19a29--56a955--main",
  "$E": "x7be19a29--56a955--container--fullscreen",
  "Y5": "x7be19a29--56a955--fullscreen",
};

module.exports = exports;
